/* eslint-disable react-refresh/only-export-components */
import { ProtectedRoute } from "@/components";
import { createBrowserRouter } from "react-router-dom";

export enum ROUTE {
  AUTH_LOGIN = "/auth/login",
  AUTH_SET_PASSWORD = "/auth/set-password",
  AUTH_PASSWORD_RESET = "/auth/password-reset",
  DASHBOARD = "/dashboard",
}

import { Navigate } from "react-router-dom";
import { isAuthenticated } from "./is-authenticated.util";
import { FC } from "react";
import { LoginPage } from "@/features/login";
import { DashboardPage } from "@/features/dashboard";
import { SetPasswordPage } from "@/features/set-password";
import { PasswordResetPage } from "@/features/password-reset";

export const DefaultPage: FC = () => {
  return (
    <Navigate
      to={isAuthenticated() ? ROUTE.DASHBOARD : ROUTE.AUTH_LOGIN}
      replace
    />
  );
};

export const router = createBrowserRouter([
  { path: "/", element: <DefaultPage /> },
  {
    path: "auth",
    children: [
      { path: "login", element: <LoginPage /> },
      { path: "set-password", element: <SetPasswordPage /> },
      { path: "password-reset", element: <PasswordResetPage /> },
    ],
  },
  {
    path: "dashboard",
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
]);
